"use client";
import WebLayout from "@/components/layout/web/WebLayout";
import CPaginationWithLinksSkeleton from "@/components/main/CPaginationWithLinksSkeleton";
import ExpertCardSkeleton from "@/components/web/main/experts/ExpertCardSkeleton";
import ExpertSmallCardSkeleton from "@/components/web/main/experts/ExpertSmallCardSkeleton";
import { PER_PAGE } from "@/configs/constants";
import { Container, Grid, Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <>
      <Container>
        <div className="flex justify-between items-center mt-[35px] mb-[26px]">
          <Skeleton width={160} height={20} />
          <Skeleton width={180} height={44} />
        </div>
        <Grid gutter={0}>
          {Array.from(Array(PER_PAGE)).map((expert, index) => (
            <Grid.Col span={12} md={6} lg={12} m={0} key={index}>
              <div className="hidden lg:block">
                <ExpertCardSkeleton className="my-2" />
              </div>
              <div className="block lg:hidden">
                <ExpertSmallCardSkeleton className="m-2" />
              </div>
            </Grid.Col>
          ))}
        </Grid>
        <CPaginationWithLinksSkeleton />
      </Container>
    </>
  );
};

export default loading;
